import { updates } from "@/mocks/home";

export default function SectionUpdates() {
  return (
    <section id="updates" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">最新动态</h2>
          <p className="mt-3 text-foreground-600 text-sm md:text-base">片库更新与平台公告实时追踪</p>
        </div>
        <div className="max-w-3xl mx-auto">
          {updates.map((item, idx) => (
            <div key={item.id} className="flex gap-4">
              <div className="flex flex-col items-center">
                <div className="w-3 h-3 rounded-full bg-primary-500 flex-shrink-0 mt-1.5"></div>
                {idx < updates.length - 1 && (
                  <div className="w-px flex-1 bg-background-300 mt-1.5"></div>
                )}
              </div>
              <div className={`pb-8 ${idx === updates.length - 1 ? "pb-0" : ""}`}>
                <div className="flex items-center gap-3 mb-1 flex-wrap">
                  <span className="text-xs text-foreground-500">{item.date}</span>
                  <span className="px-2 py-0.5 text-[11px] font-medium rounded-full bg-secondary-100 text-secondary-700">
                    {item.tag}
                  </span>
                </div>
                <h3 className="text-sm font-semibold text-foreground-900">{item.title}</h3>
                <p className="text-xs text-foreground-600 mt-1 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}